// src/components/ChatPage.jsx
import React from 'react';
import ChatbotWidget from './ChatbotWidget';

const ChatPage = () => (
  <div className="container mx-auto p-4">
    <h1 className="text-2xl font-bold mb-4">Customer Support Chat</h1>
    <ChatbotWidget />
  </div>
);

export default ChatPage;